/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.createCanvas)();
	
	(0, _module.detectScroll)();
	
	(0, _module.toggleHeader)();
	
	(0, _module.anchorLink)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 768;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// createCanvas
	// ----- BOTH
	// ------------------------------------------------------------------------
	var createCanvas = function createCanvas() {
	  var targetLeftList = document.querySelectorAll('.sw-Canvas.sw-Canvas-Left');
	  var targetLeftArray = Array.prototype.slice.call(targetLeftList, 0);
	  var fillLeft = function fillLeft(e, w) {
	    e.fillStyle = 'rgba(247, 208, 2, 1)';
	    e.beginPath();
	    if (w > breakPoint) {
	      e.moveTo(800 * 2, 0);
	      e.lineTo(1920 * 2, 0);
	      e.lineTo(1920 * 2, 125 * 2);
	    } else {
	      e.moveTo(3840 * (102 / 768), 0);
	      e.lineTo(3840, 0);
	      e.lineTo(3840, 250 * (75 / 100));
	    }
	    e.fill();
	    e.fillStyle = 'rgba(1, 142, 66, 1)';
	    e.beginPath();
	    if (w > breakPoint) {
	      e.moveTo(0, 0);
	      e.lineTo(1920 * 2, 0);
	      e.lineTo(1920 * 2, 32 * 2);
	      e.lineTo(0, 125 * 2);
	    } else {
	      e.moveTo(0, 0);
	      e.lineTo(3840, 0);
	      e.lineTo(3840, 250 * (30 / 100));
	      e.lineTo(0, 250 * (100 / 100));
	    }
	    e.fill();
	  };
	  var targetRightList = document.querySelectorAll('.sw-Canvas.sw-Canvas-Right');
	  var targetRightArray = Array.prototype.slice.call(targetRightList, 0);
	  var fillRight = function fillRight(e, w) {
	    e.fillStyle = 'rgba(247, 208, 2, 1)';
	    e.beginPath();
	    if (w > breakPoint) {
	      e.moveTo(1120 * 2, 0);
	      e.lineTo(0, 0);
	      e.lineTo(0, 125 * 2);
	    } else {
	      e.moveTo(3840 * (666 / 768), 0);
	      e.lineTo(0, 0);
	      e.lineTo(0, 250 * (75 / 100));
	    }
	    e.fill();
	    e.fillStyle = 'rgba(1, 142, 66, 1)';
	    e.beginPath();
	    if (w > breakPoint) {
	      e.moveTo(0, 0);
	      e.lineTo(1920 * 2, 0);
	      e.lineTo(1920 * 2, 125 * 2);
	      e.lineTo(0, 32 * 2);
	    } else {
	      e.moveTo(0, 0);
	      e.lineTo(3840, 0);
	      e.lineTo(3840, 250 * (100 / 100));
	      e.lineTo(0, 250 * (30 / 100));
	    }
	    e.fill();
	  };
	  targetLeftArray.forEach(function (e, i) {
	    var canvas = e.getContext('2d');
	    window.addEventListener('load', function () {
	      fillLeft(canvas, windowWidth);
	    }, false);
	    window.addEventListener('resize', function () {
	      var resizeWidth = window.innerWidth;
	      if (windowWidth != resizeWidth) {
	        canvas.clearRect(0, 0, 3840, 250);
	        fillLeft(canvas, resizeWidth);
	      }
	    }, false);
	  });
	  targetRightArray.forEach(function (e, i) {
	    var canvas = e.getContext('2d');
	    window.addEventListener('load', function () {
	      fillRight(canvas, windowWidth);
	    }, false);
	    window.addEventListener('resize', function () {
	      var resizeWidth = window.innerWidth;
	      if (windowWidth != resizeWidth) {
	        canvas.clearRect(0, 0, 3840, 250);
	        fillRight(canvas, resizeWidth);
	      }
	    }, false);
	  });
	};
	
	// ------------------------------------------------------------------------
	// detectScroll
	// ----- BOTH
	// ------------------------------------------------------------------------
	var detectScroll = function detectScroll() {
	  var targetHeader = document.getElementById('st-Header');
	  var targetTotop = document.getElementById('sw-Totop');
	  var targetHeight = 24;
	  window.addEventListener('load', function () {
	    var scrollVolume = window.pageYOffset;
	    if (scrollVolume > targetHeight) {
	      targetHeader.classList.add('is-Scrolled');
	      targetTotop.classList.add('is-Scrolled');
	    } else {
	      targetHeader.classList.remove('is-Scrolled');
	      targetTotop.classList.remove('is-Scrolled');
	    }
	  });
	  window.addEventListener('scroll', function () {
	    var scrollVolume = window.pageYOffset;
	    if (scrollVolume > targetHeight) {
	      targetHeader.classList.add('is-Scrolled');
	      targetTotop.classList.add('is-Scrolled');
	    } else {
	      targetHeader.classList.remove('is-Scrolled');
	      targetTotop.classList.remove('is-Scrolled');
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	  var targetHeader = document.getElementById('st-Header');
	  var targetButton = document.getElementById('st-Header_Button');
	  targetButton.addEventListener('click', function () {
	    if (targetHeader.classList.contains('is-Opened')) {
	      targetHeader.classList.remove('is-Opened');
	    } else {
	      targetHeader.classList.add('is-Opened');
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	exports.createCanvas = createCanvas;
	exports.detectScroll = detectScroll;
	exports.toggleHeader = toggleHeader;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js